import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import MentionCardInstagram from './channels/instagram/MentionCardInstagram';
import MentionCardYoutube from './channels/youtube/MentionCardYoutube';

import './mention-card.scss';

import type { ChannelTypes, MentionCardModalItem, MentionCardViewType } from 'types';

type Props = {
  post: MentionCardModalItem,
  hideExternalLink?: boolean,
  maxRowCount?: number,
  channel: ChannelTypes,
  viewType: MentionCardViewType,
  children?: React.ReactNode,
  isLimitedKeywords?: boolean,
  hideAdditionalStatusLabel?: boolean
};

class MentionCard extends React.PureComponent<Props> {
  static defaultProps = {
    viewType: 'grid'
  };

  renderInstagram(): React.ReactNode {
    const {
      post,
      viewType,
      maxRowCount,
      hideExternalLink,
      children,
      isLimitedKeywords,
      hideAdditionalStatusLabel
    } = this.props;

    return (
      <MentionCardInstagram
        post={post}
        viewType={viewType}
        maxRowCount={maxRowCount}
        hideExternalLink={hideExternalLink}
        isLimitedKeywords={isLimitedKeywords}
        hideAdditionalStatusLabel={hideAdditionalStatusLabel}
      >
        {children}
      </MentionCardInstagram>
    );
  }

  renderYoutube(): React.ReactNode {
    const {
      post,
      viewType,
      maxRowCount,
      hideExternalLink,
      children,
      hideAdditionalStatusLabel
    } = this.props;

    return (
      <MentionCardYoutube
        post={post}
        viewType={viewType}
        maxRowCount={maxRowCount}
        hideExternalLink={hideExternalLink}
        hideAdditionalStatusLabel={hideAdditionalStatusLabel}
      >
        {children}
      </MentionCardYoutube>
    );
  }

  renderContents(): React.ReactNode | undefined | null {
    const { channel } = this.props;

    if (channel === 'instagram') {
      return this.renderInstagram();
    }

    if (channel === 'youtube') {
      return this.renderYoutube();
    }

    return null;
  }

  render(): React.ReactNode {
    const { channel, viewType } = this.props;

    if (isNil(channel)) {
      return null;
    }

    const containerClasses = classnames('mention-card', {
      [`mention-card--view-type-${String(viewType)}`]: Boolean(viewType)
    });

    return (
      <div className={containerClasses}>
        {this.renderContents()}
      </div>
    );
  }
}

export default MentionCard;
